import { hexToHsl, hslToHex } from "~/utils";

export const clamp = (x: number, min: number, max: number) =>
    Math.min(Math.max(x, min), max);

export const lerp = (x: number, y: number, t: number) => x + (y - x) * t;

export const lerpColor = (c1: string, c2: string, t: number) => {
    const r1 = parseInt(c1.slice(1, 3), 16);
    const g1 = parseInt(c1.slice(3, 5), 16);
    const b1 = parseInt(c1.slice(5, 7), 16);
    const r2 = parseInt(c2.slice(1, 3), 16);
    const g2 = parseInt(c2.slice(3, 5), 16);
    const b2 = parseInt(c2.slice(5, 7), 16);
    const r = Math.round(lerp(r1, r2, t));
    const g = Math.round(lerp(g1, g2, t));
    const b = Math.round(lerp(b1, b2, t));

    return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
};

export const equals = (a: number, b: number) => Math.abs(a - b) < 1e-6;

export const darken = (hex: string, factor = 0.2) => {
    const [h, s, l] = hexToHsl(hex);
    const newL = Math.max(0, l - l * factor);

    return hslToHex(h, s, newL);
};
